import { render, staticRenderFns } from "./IssueTrackerForm.vue?vue&type=template&id=7831019c&"
import script from "./IssueTrackerForm.vue?vue&type=script&lang=js&"
export * from "./IssueTrackerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports